import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  globalFileServer,
  globalFileIcon,
  newGlobalFileServer,
} from "../../../../axiosInstance";
import ProductInfo from "../../productInfo/ProductInfo";
import { Settings } from "lucide-react";

const Detailes = ({
  element,
  familyProd = false,
  showPrice = true,
  inCart,
  productPopUp,
  comparePricesPopUp,
  srcPrev,
  showProductEdit = false,
  isStaff = false,
  weightJump = 1,
  productLocationPopUp,
  /** Small controls on the image (e.g. shopping list); keep image area clear of cart controls */
  imageCornerActions = null,
  /** Bottom action row (cart); stops propagation so taps don’t open the product modal */
  footerSlot = null,
}) => {
  const mediaArray = Array.isArray(element?.media) ? element.media : [];

  let initialMediaIndex = -1;
  for (let i = 0; i < mediaArray.length; i++) {
    if (mediaArray[i]?.isDefault === true) {
      initialMediaIndex = i;
      break;
    }
  }
  if (initialMediaIndex === -1 && mediaArray.length > 0) {
    initialMediaIndex = mediaArray.length - 1;
  }

  const [mediaIndex, setMediaIndex] = useState(initialMediaIndex);

  if (!element) return null;
  const handleError = () => {
    if (mediaIndex > 0) {
      setMediaIndex((prev) => prev - 1);
    } else {
      setMediaIndex(-1);
    }
  };

  const imageSrc =
    srcPrev != null
      ? srcPrev
      : mediaIndex >= 0 && mediaArray[mediaIndex]?.path
        ? `${newGlobalFileServer}${mediaArray[mediaIndex].path}?width=150&height=150`
        : `${globalFileServer}placeholder.jpg`;

  const hasPromotion = element.pricing?.promotions?.length > 0;

  return (
    <div className="item-card-details" onClick={productPopUp}>
      <div
        className={
          inCart
            ? "card-img-in-card"
            : element.availability.availableQuantity > 0
              ? "card-img"
              : "regular-card"
        }
        style={srcPrev ? { width: "100%", maxWidth: "100%" } : undefined}
      >
        {imageCornerActions ? (
          <div
            className="item-card-details__corner"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            {imageCornerActions}
          </div>
        ) : null}
        <img
          className="img"
          loading="lazy"
          src={imageSrc}
          onError={handleError}
          alt={element.name || "product"}
        />
        {element.kosherSupervision?.length > 0 &&
          element.kosherSupervision[0].supervisionAgency &&
          element.kosherSupervision[0].supervisionAgency.img?.path &&
          element.kosherSupervision[0].supervisionAgency.img.path !==
            "19.svg" && (
            <img
              className="item-card-details__kosher-badge"
              loading="lazy"
              src={
                globalFileIcon +
                element.kosherSupervision[0].supervisionAgency.img.path
              }
              alt={
                element.kosherSupervision[0].supervisionAgency.name || "כשרות"
              }
            />
          )}
        {isStaff &&
          (element.availability["availableQuantity"] >= weightJump ? (
            <div
              className="location staff-on-image"
              onClick={(e) => {
                e.stopPropagation();
                productLocationPopUp?.(element);
              }}
            >
              <button
                type="button"
                className={`inventory ${
                  !element.showOutOfStock ? "inventory-warn" : "gray"
                }`}
                data-tip
                data-for="registerTipLocation"
              >
                {element.availability["availableQuantity"]}
              </button>
            </div>
          ) : !element.showOutOfStock ? (
            <div
              className="location staff-on-image"
              onClick={(e) => {
                e.stopPropagation();
                productLocationPopUp?.();
              }}
            >
              <button
                type="button"
                className="inventory inventory-warn"
                data-tip
                data-for="registerTipLocation"
              >
                X
              </button>
            </div>
          ) : (
            <div
              className="location staff-on-image"
              onClick={(e) => {
                e.stopPropagation();
                productLocationPopUp?.(element);
              }}
            >
              <button
                type="button"
                className="inventoryEnd-btn"
                data-tip
                data-for="registerTipLocation"
              >
                חסר
              </button>
            </div>
          ))}
        {showProductEdit && (
          <div
            className="edit-prod-cls"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <NavLink
              to={"/edit-product/" + element.productId}
              data-tip
              data-for="registerTipDefinition"
              className="hz-icon-btn hz-icon-btn--settings"
              aria-label="הגדרות מוצר"
            >
              <span aria-hidden className="card-gear-icon">
                <Settings size={18} strokeWidth={2} />
              </span>
            </NavLink>
          </div>
        )}
      </div>

      <div className="desc">
        <span className="product-info">
          <ProductInfo selectedProd={element} familyProd={familyProd} />
        </span>
        <div className="kosher-and-price">
          {hasPromotion &&
            element.pricing.promotions[0].promoType === "FLAT" && (
              <span className="current-price current-price--sale">
                {element.pricing.promotions[0].discountValue}
              </span>
            )}
          {hasPromotion &&
            element.pricing.promotions[0].promoType === "PERCENT" && (
              <span className="current-price current-price--sale">
                {(element.pricing.price / 100) *
                  element.pricing.promotions[0].discountValue}
              </span>
            )}
          {showPrice && (
            <div className="price-main-cont">
              {element.pricing?.price != null && (
                <span
                  className={
                    hasPromotion &&
                    element.pricing.promotions[0].promoType !== "QUANTITY_PRICE"
                      ? "price with-sale"
                      : "current-price"
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    comparePricesPopUp?.();
                  }}
                  data-tip
                  data-for="registerTipComparePrice"
                >
                  {element.pricing.price}
                </span>
              )}
            </div>
          )}
        </div>
      </div>

      {footerSlot ? (
        <div
          className="item-card-details__footer"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          {footerSlot}
        </div>
      ) : null}
    </div>
  );
};

export default Detailes;
